import { ProducingOffice } from "pmt-types/src/models/ProducingOffice.ts";
import { useMutationSearchEntities } from "./useMutationSearchEntities.ts";

export const useMutationSearchProducingOffices = () =>
  useMutationSearchEntities<ProducingOffice>("producingOffices");
